import React from "react";
import {  View, Page, Text, Link,  Font, Document, StyleSheet  } from '@react-pdf/renderer';
import { useTranslation, Trans } from 'react-i18next';

var moment = require('moment')

Font.register({ family: 'Poppins', src: process.env.PUBLIC_URL+'/fonts/Poppins-Bold.ttf', fontStyle: 'normal', fontWeight: 'bold' });
Font.register({ family: 'Poppins', src: process.env.PUBLIC_URL+'/fonts/Poppins-Light.ttf', fontStyle: 'normal', fontWeight: 'light' });
Font.register({ family: 'Poppins', src: process.env.PUBLIC_URL+'/fonts/Poppins-Regular.ttf', fontStyle: 'normal', fontWeight: 'regular' });
const d = localStorage.getItem('isDead') === "true"
const color = d? 'darkslateblue' : 'dodgerblue'
const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 40,
        paddingHorizontal: 20,
    },
    title: {
        fontSize: 28,
        textAlign: 'left',
        fontWeight: 'bold'
    },
    bordered :{
        padding:12,
        border:1,
        borderColor: color,
        marginBottom: 10,
        paddingBottom:30,
        paddingTop:15,
        borderRadius:15
    },
    alertWarning :{
        paddingBottom:10,
        paddingTop:5,
        paddingHorizontal:10,
        border:1,
        borderColor: "khaki",
        backgroundColor: "lemonchiffon",
        borderRadius:5,
        marginTop: 10,
        marginbottom: 10
    },
    subtitle: {
        fontSize: 12,
        marginBottom:5,
        color: color,
        fontFamily:'Poppins',
        fontWeight:'bold'
    },
    text: {
        marginTop:5,
        fontSize: 11,
        textAlign: 'justify',
        fontFamily:'Poppins',
        fontWeight: "light"
    },
    textSm: {
        marginTop:5,
        fontSize: 8,
        textAlign: 'justify',
        fontFamily:'Poppins',
        fontWeight: "light"
    },
    textFlex: {
        marginTop:7,
        fontSize: 9,
        textAlign: 'justify',
        fontFamily:'Poppins',
        fontWeight: "light",
        display:'flex',
        width: 450
    },
    spacing:{
        paddingTop:15
    },
    tableLike : {
        flexDirection : 'row',
        display:'flex'
    },
    textInline: {
        marginBottom:5,
        fontSize: 11,
        textAlign: 'justify',
        fontFamily:'Poppins',
        fontWeight: "light",
        width: 600,
        display: 'flex'
    },
    borderTop:{
        height:1,
        borderTop:1,
        borderColor: 'lightgrey',
        marginTop:7,
        marginBottom:5
    },
    signature:{
        height:100,
        width:200,
        border:1,
        borderColor: 'lightgrey',
        borderRadius:5,
        marginTop:7,
        marginBottom:5,
        padding:5
    },
    crossedBox:{
        height:24,
        width:24,
        border:1,
        borderColor: 'lightgrey',
        borderRadius:3,
        margin:7,
        display:'flex',
        paddingLeft:4,
        paddingTop:2
    },
    label: {
        fontSize: 9,
        marginBottom:5,
        color: color,
        width: 170,
        fontFamily:'Poppins',
        fontWeight: "light",
        display: 'flex'
    },
    labelLg: {
        fontSize: 9,
        marginBottom:5,
        color: color,
        width: 220,
        fontFamily:'Poppins',
        fontWeight: "light",
        display: 'flex'
    },
    typeLabel: {
        fontSize: 9,
        marginBottom:5,
        color: color,
        width: 170,
        fontFamily:'Poppins',
        fontWeight: "normal",
        display: 'flex'
    },
    data: {
        marginBottom:5,
        fontSize: 11,
        fontFamily:'Poppins',
        fontWeight: "light",
        width: 250,
        display: 'flex'
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 100,
    },
    header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: 'center',
        color: 'grey',
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 9,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
});



function Pdf  (props) {
    const { i18n } = useTranslation();
    const Age= JSON.parse(localStorage.getItem("Age"))
    const remark = JSON.parse(localStorage.getItem('remark'))
    const information = JSON.parse(localStorage.getItem('information'))
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'))
    const family = JSON.parse(localStorage.getItem('family'))
    const children = JSON.parse(localStorage.getItem('children'))
    const parent = JSON.parse(localStorage.getItem('parent'))
    const other = JSON.parse(localStorage.getItem('other'))
    const familyOther = JSON.parse(localStorage.getItem('familyOther'))
    const familyParent = JSON.parse(localStorage.getItem('familyParent'))
    const familyPartner = JSON.parse(localStorage.getItem('familyPartner'))
    const job = JSON.parse(localStorage.getItem('job'))
    const jobEmployee = JSON.parse(localStorage.getItem('jobEmployee'))
    const jobIndependant = JSON.parse(localStorage.getItem('jobIndependant'))
    const jobPartner = JSON.parse(localStorage.getItem('jobPartner'))
    const jobPartnerEmployee = JSON.parse(localStorage.getItem('jobPartnerEmployee'))
    const jobPartnerIndependant = JSON.parse(localStorage.getItem('jobPartnerIndependant'))
    const jobPartnerStudent = JSON.parse(localStorage.getItem('jobPartnerStudent'))
    const jobStudent = JSON.parse(localStorage.getItem('jobStudent'))
    const circumstances = JSON.parse(localStorage.getItem('circumstances'))
    const witness = JSON.parse(localStorage.getItem('witness'))
    const item = JSON.parse(localStorage.getItem('item'))
    const physical = JSON.parse(localStorage.getItem('physical'))
    const intervention = JSON.parse(localStorage.getItem('intervention'))

    let ChildrenData = ''
    let ParentData = ''
    let OtherData = ''
    let WitnessesData = ''
    let ItemsData = ''
    let PartnerJobs = ''
    let Avantages = ''
    let Jobs = ''
    let PartnerAvantages = ''
    if (!!children) {
        ChildrenData = []
        for (let i= 0; i < Object.entries(children).length; i++){
            ChildrenData.push(
                <View key={'child'+ i} wrap={false}>
                    <View style={styles.borderTop}/>
                    <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{d? i18n.t("Enfant"): i18n.t("Mon enfant")}</Text>
                        <Text style={styles.label}>{i18n.t("Nom, prénom")}:</Text>
                        <Text style={styles.data}>{children[i]["name"] + " " + children[i]["firstname"]}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{i18n.t("BIRTHDATEDATA")}:</Text>
                        <Text style={styles.data}>{moment(children[i]["birthdate"]).format('DD/MM/YYYY')}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{d ? i18n.t("A la charge du défunt") : i18n.t("A ma charge") }:</Text>
                        <Text style={styles.data}>{i18n.t((children[i]["isCharge"].toUpperCase()))}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{i18n.t("Cohabitant")}:</Text>
                        <Text style={styles.data}>{i18n.t(children[i]["isCohabitant"].toUpperCase()) } {((children[i]["isCohabitant"] === "partiellement" && !children[i]["isPartialCohabitant"] === "other") && i18n.t(children[i]["isPartialCohabitant"]) )} {((children[i]["isCohabitant"] === "partiellement" && children[i]["isPartialCohabitant"] === "other") && children[i]["cohabitantDetail"] )}</Text>
                    </View>
                </View>
            )
        }
    }
    if (!!parent){
        ParentData = []
        for (let i= 0; i < Object.entries(parent).length; i++){
            ParentData.push(
                <View wrap={false} key={'par'+ i}>
                    <View style={styles.borderTop}/>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{d? i18n.t("Parent"): i18n.t("Mon parent")}</Text>
                        <Text style={styles.label}>{i18n.t("Nom, prénom")}:</Text>
                        <Text style={styles.data}>{parent[i]["name"]} {parent[i]["firstname"]}</Text>
                    </View>

                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{i18n.t("BIRTHDATEDATA")}:</Text>
                        <Text style={styles.data}>{moment(parent[i]["birthdate"]).format('DD/MM/YYYY')}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{!d && Age < 16 && i18n.t("A sa charge") }{!d && Age > 16 && i18n.t("A ma charge")}{d && Age < 16 && i18n.t("A sa charge") }{d && Age > 16 && i18n.t("A la charge du défunt")}:</Text>
                        <Text style={styles.data}>{i18n.t((parent[i]["isCharge"].toUpperCase()))}</Text>
                    </View>
                </View>
            )
        }
    }
    if (!!other){
        OtherData = []
        for (let i= 0; i < Object.entries(other).length; i++){
            OtherData.push(
                <View wrap={false} key={'oth'+ i}>
                    <View style={styles.borderTop}/>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{!d? i18n.t("Les autres personnes dans ma maison"): i18n.t("Les autres personnes")}</Text>
                        <Text style={styles.label}>{i18n.t("Nom, prénom")}:</Text>
                        <Text style={styles.data}>{other[i]["name"] + " " + other[i]["firstname"]}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{i18n.t("BIRTHDATEDATA")}:</Text>
                        <Text style={styles.data}>{moment(other[i]["birthdate"]).format('DD/MM/YYYY')}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{!d && Age < 16 && i18n.t("A sa charge") }{!d && Age > 16 && i18n.t("A ma charge")}{d && Age < 16 && i18n.t("A sa charge") }{d && Age > 16 && i18n.t("A la charge du défunt")}:</Text>
                        <Text style={styles.data}>{i18n.t((other[i]["isCharge"].toUpperCase()))}</Text>
                    </View>
                    {!!other[i]["link"] &&
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("")}</Text>
                        <Text style={styles.label}>{d? i18n.t("Lien avec le défunt") : i18n.t("Lien entre nous")}:</Text>
                        <Text style={styles.data}>{other[i]["link"]}</Text>
                    </View>
                    }
                </View>
            )
        }
    }
    if (!!witness){
        WitnessesData = []
        for (let i= 0; i < Object.entries(witness).length; i++){
            WitnessesData.push(
                <View wrap={false} key={'wit'+ i}>
                    <View style={styles.borderTop}/>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("field49Firstname")}:</Text>
                        <Text style={styles.data}>{witness[i]["firstname"]}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("field49Name")}:</Text>
                        <Text style={styles.data}>{witness[i]["name"] }</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.typeLabel}>{i18n.t("ADDRESSDATA")}:</Text>
                        <Text style={styles.data}>{witness[i]["Field49AddressStreet"]} {witness[i]["Field49AddressStreetNumber"]}, {witness[i]["Field49AddressStreetBox"]} -
                            {witness[i]["Field49AddressZip"]} {witness[i]["Field49AddressTown"]}</Text>
                    </View>
                </View>
            )
        }
    }
    if (!!item){
        ItemsData= []
        for (let i= 0; i < Object.entries(item).length; i++){
            ItemsData.push(
                <View wrap={false} key={'it'+ i}>
                    <View style={styles.borderTop}/>
                    <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("field511Objet")}:</Text>
                        <Text style={styles.data}>{item[i]["Field511Objet"]}</Text>
                    </View>
                    <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("field512Description")}:</Text>
                        <Text style={styles.data}>{item[i]["Field512Description"] }</Text>
                    </View>
                    <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("field513Date")}:</Text>
                        <Text style={styles.data}>{item[i]["Field513Date"]}</Text>
                    </View>
                    <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("field514Amount")}:</Text>
                        <Text style={styles.data}>{item[i]["Field514Amount"]} €</Text>
                    </View>
                </View>
            )
        }
    }
    if (d && !!jobPartner){
        PartnerJobs = []
        for (let [key, value] of Object.entries(jobPartner.PartnerJobCheckbox)){
            let jobKey = key === "field31SituationAutre" ? jobPartner.Field31SituationAutreDetail : key
            let since = "Since"+key
            if (value){
                PartnerJobs.push(i18n.t(jobKey)+ " ("+ i18n.t("beginDate").toLowerCase()+ " " + jobPartner[since] + ") -")
            }
        }
    }
    if (!!jobEmployee && !!jobEmployee.Field37AdvantangeCheckbox) {
        Avantages = []
        for (let [key] of Object.entries(jobEmployee.Field37AdvantangeCheckbox)) {
            let jobEmployeeKey = key
            if (Object.entries(jobEmployee.Field37AdvantangeCheckbox).length > 1 && Avantages.length < Object.entries(jobEmployee.Field37AdvantangeCheckbox).length - 1) {
                Avantages.push(i18n.t("field37Advantages" + jobEmployeeKey) + i18n.t(" et "))
            } else {
                //console.log( Object.entries(jobEmployee.Field37AdvantangeCheckbox).length)
                Avantages.push(key === "Other" ? jobEmployee.Field3701AdvantagesDetail : i18n.t("field37Advantages" + jobEmployeeKey))
            }
        }
    }
    if (!!jobPartnerEmployee && !!jobPartnerEmployee.Field37AdvantangeCheckbox) {
        PartnerAvantages = []
        for (let [key] of Object.entries(jobPartnerEmployee.Field37AdvantangeCheckbox)){
            let jobPartnerEmployeeKey = key
            if  (Object.entries(jobPartnerEmployee.Field37AdvantangeCheckbox).length > 1 && PartnerAvantages.length < Object.entries(jobPartnerEmployee.Field37AdvantangeCheckbox).length-1 ){
                PartnerAvantages.push( i18n.t("field37Advantages"+jobPartnerEmployeeKey) + i18n.t(" et "))
            }else{
                PartnerAvantages.push(key === "Other" ? jobPartnerEmployee.Field3701AdvantagesDetail : i18n.t("field37Advantages"+jobPartnerEmployeeKey))
            }
        }
    }
    if (!!job){
        Jobs = []
        for (let [key, value] of Object.entries(job.checkbox)){
            let since = "Since"+key
            let jobKey = key === "field31SituationAutre" ? job.Field31SituationAutreDetail : key
            if (value){

                Jobs.push(i18n.t(jobKey)+ " ("+ i18n.t("beginDate").toLowerCase() + " " + job[since] + ") -")

            }

        }
    }



    return (

        <Document>
            <Page style={styles.body}>
                <Text style={styles.header} fixed>
                    ~ {i18n.t("Questionnaire après un accident avec dommages corporels")} ~
                </Text>
                <View style={styles.bordered}>
                    <Text style={styles.subtitle}>
                        {i18n.t("Numéro de référence") + ": "}
                    </Text><Text style={styles.textInline}>{information.Field1ReferenceFile}</Text>
                </View>
                <View style={styles.bordered}>
                    <Text style={styles.subtitle}>
                        {!information.Field0CourtierName ? i18n.t("Nom de l’assureur qui demande de fournir les informations") + ": " : i18n.t("Nom de l’intermédiaire d'assurance qui me demande de fournir les informations") + ": " }
                    </Text>
                    <Text style={styles.text}>
                        {!information.Field0CourtierName ?  information.Field0InsurerName : information.Field0CourtierName  }
                    </Text>
                </View>
                <View style={styles.bordered}>
                    <Text style={styles.subtitle}>
                        { d && i18n.t("Les informations du défunt sont") + ": "}
                        { (!d && remark.FieldTiercePersonne === "no") && i18n.t("Les coordonnées de la victime sont")  + ": " }
                        { (!d && remark.FieldTiercePersonne === "no") && i18n.t("Mes coordonnées sont")  + ": " }
                    </Text>
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("Nom, prénom")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field7Name} {personalDetails.Field8Firstname}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("BIRTHDATEDATA")}:</Text>
                        <Text style={styles.textInline}>{moment(personalDetails.Field9Birthdate).format('DD/MM/YYYY')}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("SEXDATA")}:</Text>
                        <Text style={styles.textInline}>{i18n.t(personalDetails.Field10Sex.toUpperCase())}</Text>
                    </View>
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("ADDRESSDATA")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field11AddressStreet} {personalDetails.Field11AddressStreetNumber}, {personalDetails.Field11AddressStreetBox} - {personalDetails.Field11AddressZip} {personalDetails.Field11AddressTown} {personalDetails.Field17CountryOther !== "" ? personalDetails.Field17CountryOther : i18n.t("Belgique")}  </Text>
                    </View>
                    {personalDetails.Field12Phone !== "" &&
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("PHONEDATA")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field12Phone}</Text>
                    </View>
                    }
                    {personalDetails.Field13GSM !== "" &&
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("GSMDATA")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field13GSM}</Text>
                    </View>
                    }
                    {personalDetails.Field14Email !== "" &&
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("EMAILDATA")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field14Email}</Text>
                    </View>
                    }
                    {personalDetails.Field15Bank !== "" &&
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("BANKDATA")}:</Text>
                        <Text style={styles.textInline}>{personalDetails.Field15Bank}</Text>
                    </View>
                    }
                    {personalDetails.Field16Civil !== "" &&
                     <View style={styles.tableLike}>
                        <Text style={styles.labelLg}>{i18n.t("CIVILDATA")}:</Text>
                        <Text style={styles.textInline}>{i18n.t(personalDetails.Field16Civil)}</Text>
                    </View>
                    }

                </View>
                <View style={styles.bordered}>
                    {(family.Field17HasPartner ==="no" && family.Field18HasChildren ==="no" && family.Field19HasParents ==="no" && family.Field20HasPersons ==="no") &&
                    <Text style={styles.subtitle}>
                        {d? i18n.t("Le défunt vivait seul.") : i18n.t("Je déclare de vivre seul.")}
                    </Text>
                    }
                    {(family.Field17HasPartner ==="yes" || family.Field18HasChildren ==="yes" || family.Field19HasParents ==="yes" || family.Field20HasPersons ==="yes") &&
                    <Text style={styles.subtitle}>
                        {d? i18n.t("Je déclare que le foyer du défunt se compose comme repris ci-dessous") : i18n.t("Je déclare que mon foyer se compose comme repris ci-dessous") }:
                    </Text>
                    }
                    { !!familyPartner &&
                    <View  wrap={false}>
                        <View style={styles.borderTop}/>
                        <View style={styles.tableLike}>
                            <Text style={styles.typeLabel}>{d? i18n.t("Conjoint ou partenaire"): i18n.t("Mon conjoint ou partenaire")}</Text>
                            <Text style={styles.label}>{i18n.t("Nom, prénom")}:</Text>
                            <Text style={styles.data}>{familyPartner.Field22Name + " " + familyPartner.Field23Firstname}</Text>
                        </View>
                        <View style={styles.tableLike}>
                            <Text style={styles.label}>{i18n.t("")}</Text>
                            <Text style={styles.label}>{i18n.t("BIRTHDATEDATA")}:</Text>
                            <Text style={styles.data}>{moment(familyPartner.Field24Birthdate).format('DD/MM/YYYY')}</Text>
                        </View>
                        {!!familyPartner.Field25Situation &&
                        <View style={styles.tableLike}>
                            <Text style={styles.label}>{i18n.t("")}</Text>
                            <Text style={styles.label}>{i18n.t("JOBPARTNER")}:</Text>
                            <Text style={styles.data}>{i18n.t(familyPartner.Field25Situation)}</Text>
                        </View>
                        }
                    </View>
                    }
                    {!!children &&
                    ChildrenData
                    }
                    {!!familyParent &&
                    ParentData
                    }
                    {!!familyOther &&
                    OtherData
                    }
                </View>
                {!!job &&
                <View style={styles.bordered}>
                    <Text style={styles.subtitle}>
                        {(d ? i18n.t("Profession du défunt") : i18n.t("Ma profession") + ": ")}
                    </Text>
                    {(!d && personalDetails.Field05Loss === "yes" ) &&
                    <Text style={styles.text}>
                        {i18n.t("Je déclare que j’ai subi une perte de revenu à la suite de l’accident. Je suis ") }
                        {Jobs}
                    </Text>
                    }
                    {(d || personalDetails.Field05Loss === "unknown" ) &&
                    <Text style={styles.text}>
                        {d ?  i18n.t("Le défunt était "): i18n.t("Je suis ")}
                        {Jobs}
                    </Text>
                    }
                    {(!!jobEmployee) &&
                    <View wrap={false}>
                        <View style={styles.alertWarning}>
                            <Text style={styles.textSm}>{i18n.t("joindre preuve revenu")}</Text>
                        </View>
                        <Text style={styles.text}>
                            {d? i18n.t("Le défunt travaillait à") : i18n.t("Mon employeur est")} {jobEmployee.Field32Name}. {jobEmployee.Field33AddressStreet} {jobEmployee.Field33AddressStreetNumber}, {jobEmployee.Field33AddressStreetBox} - {jobEmployee.Field33AddressZip} {jobEmployee.Field33AddressTown}
                        </Text>
                        <Text style={styles.text}>
                             {d? i18n.t("Le défunt travaillait à ") : i18n.t("Je travaille à ")}
                             {i18n.t(jobEmployee.Field34Regime)} {i18n.t(jobEmployee.Field34RegimeTempsPartielType)} {i18n.t(jobEmployee.Field34RegimeTempsPartielStatut)} {jobEmployee.Field34RegimeTempsPartielTypeDetail}
                             {i18n.t("- correspondant à")} {jobEmployee.Field35Hours} {i18n.t("heures par semaine.")}
                        </Text>
                        <Text style={styles.text}>
                            {d? i18n.t("Il gagnait") : i18n.t("Je gagne")} {jobEmployee.Field3601WageBrut && jobEmployee.Field3601WageBrut + " " + i18n.t("euros brut")} {jobEmployee.Field3602WageImposable && jobEmployee.Field3602WageImposable + " " +i18n.t("euros imposables")} {jobEmployee.Field3603WageNet && jobEmployee.Field3603WageNet + " " +i18n.t("euros en net")} {jobEmployee.Field36Wage === "heure" && i18n.t("par heure")}
                            {jobEmployee.Field36Wage === "mensuel" && i18n.t("mensuellement")}
                            {jobEmployee.Field36Wage === "annuel" && i18n.t("par an")}.
                        </Text>
                        {jobEmployee.Field37Advantages === "yes" &&
                        <Text style={styles.text}>
                            {d? i18n.t( "Ses autres avantages consistaient en") : i18n.t("Mes autres avantages consistent en")} {Avantages}.
                        </Text>
                        }
                    </View>
                    }

                    {!!jobIndependant &&
                    <View wrap={false}>
                        <View style={styles.alertWarning}>
                            <Text style={styles.textSm}>{i18n.t("joindre avertissement")}</Text>
                        </View>
                        <Text style={styles.text}>
                            {d? i18n.t("Le défunt était indépendant à titre") :i18n.t("Je suis indépendant à titre")} {i18n.t(jobIndependant.Field38Titre)}. {jobIndependant.Field39BCEempty && (!d? i18n.t("Je n’ai pas de numéro BCE") : i18n.t("Le défunt n’avait pas de numéro BCE"))  }
                        </Text>
                        <Text style={styles.text}>
                            {!!jobIndependant.Field39BCE && i18n.t("Mon numéro BCE est") + " " + jobIndependant.Field39BCE }
                        </Text>
                        <Text style={styles.text}>
                            {jobIndependant.Field40Status === "dirigeant" && (d? i18n.t("Le défunt travaillait en tant que dirigeant d’une société et il gagnait ainsi") : i18n.t("Je travaille en tant que dirigeant d’une société et je gagne ainsi")) + " " + jobIndependant.Field40StatusBenefice + " "}
                            {jobIndependant.Field40Status === "societe" &&(d? i18n.t("Le défunt travaillait en tant que société d’une personne et il gagnait ainsi") : i18n.t("Je travaille en tant que société d’une personne et je gagne ainsi")) + " " + jobIndependant.Field40StatusBenefice + " "}
                            {jobIndependant.Field40Status === "personnephysique" && (d? i18n.t("Le défunt travaillait en tant qu'indépendant personne physique et il gagnait ainsi") : i18n.t("Je travaille en tant qu'indépendant personne physique et je gagne ainsi")) + " " + jobIndependant.Field40StatusBenefice + " "}
                            {i18n.t("en bénéfices imposables et le montant des frais fixes est à")} {jobIndependant.Field40StatusFrais} {i18n.t("euros")}.
                        </Text>
                    </View>
                    }


                    {!!jobStudent &&
                    <View wrap={false}>
                        <View style={styles.spacing}/>
                        <Text style={styles.text}>
                            {(d? i18n.t("L'école du défunt était") :i18n.t("Mon école est")) + " " + jobStudent.Field43School}
                        </Text>
                        <Text style={styles.text}>
                            {(d? i18n.t("Il y faisait des études de") :i18n.t("J’y fais des études de")) + " " + jobStudent.Field44Nature}
                        </Text>
                        <Text style={styles.text}>
                            {(d? i18n.t("C’était une formation de") :i18n.t("C’est une formation de")) + " " + jobStudent.Field45Duration + " " + i18n.t("ans")}
                        </Text>
                        <Text style={styles.text}>
                            {(d? i18n.t("Il se trouvait en") :i18n.t("Je me trouve en")) + " " + jobStudent.Field46Year} {jobStudent.Field46Year === "1" ? i18n.t("ière") : i18n.t("ième")} {i18n.t("année")}
                        </Text>
                    </View>
                    }

                    {(d && personalDetails.Field05Loss === "unknown" ) &&
                    <Text style={styles.text}>
                        { i18n.t("Je déclare ne pas encore savoir si je vais subir des pertes de revenu à la suite de l’accident.") }

                    </Text>
                    }
                    {(d && personalDetails.Field05Loss === "no" ) &&
                    <Text style={styles.text}>
                        { i18n.t("Je déclare ne pas avoir subi des pertes de revenu à la suite de l’accident.") }

                    </Text>
                    }
                </View>}
                {(d && jobPartner) &&
                <View wrap={false} style={styles.bordered}>
                    <Text style={styles.subtitle}>
                        { i18n.t('MariedJOBTITLEDEATH') + ": "}
                    </Text>
                    <Text style={styles.text}>{PartnerJobs}</Text>
                    {!!jobPartnerEmployee &&
                    <View wrap={false}>
                        <View style={styles.alertWarning}>
                            <Text style={styles.textSm}>{i18n.t("joindre preuve revenu")}</Text>
                        </View>
                        <Text style={styles.text}>
                            { i18n.t("MariedLe défunt était salarié")}</Text>
                        <Text style={styles.text}>
                            { i18n.t("MariedDonnées de l'employeur") }: {jobPartnerEmployee.Field32Name}. {jobPartnerEmployee.Field33AddressStreet} {jobPartnerEmployee.Field33AddressStreetNumber}, {jobPartnerEmployee.Field33AddressStreetBox} - {jobPartnerEmployee.Field33AddressZip} {jobPartnerEmployee.Field33AddressTown}
                        </Text>
                        <Text style={styles.text}>
                             {i18n.t("MariedRégime de travail")}:
                             {i18n.t(jobPartnerEmployee.Field34Regime)}
                             {i18n.t(jobPartnerEmployee.Field34RegimeTempsPartielType)}
                             {i18n.t(jobPartnerEmployee.Field34RegimeTempsPartielStatut)}
                             {jobPartnerEmployee.Field34RegimeTempsPartielTypeDetail}
                             {i18n.t("- correspondant à")} {jobPartnerEmployee.Field35Hours} {i18n.t("heures par semaine.")}
                        </Text>
                        <Text style={styles.text}>
                            {i18n.t("MariedLe salaire du défunt")} :  {jobPartnerEmployee.Field3601WageBrut && jobPartnerEmployee.Field3601WageBrut + " " + i18n.t("euros brut")} {jobPartnerEmployee.Field3602WageImposable && jobPartnerEmployee.Field3602WageImposable + " " +i18n.t("euros imposables")} {jobPartnerEmployee.Field3603WageNet && jobPartnerEmployee.Field3603WageNet + " " +i18n.t("euros en net")} {jobPartnerEmployee.Field36Wage === "heure" && i18n.t("par heure")}
                            {jobPartnerEmployee.Field36Wage === "mensuel" && i18n.t("mensuellement")}
                            {jobPartnerEmployee.Field36Wage === "annuel" && i18n.t("par an")}.
                        </Text>
                        {jobPartnerEmployee.Field37Advantages === "yes" &&
                        <Text style={styles.text}>
                            {i18n.t( "Mariedfield3701AdvantagesDetail") } : {PartnerAvantages}.
                        </Text>
                        }
                    </View>
                    }

                    {!!jobPartnerIndependant &&
                    <View wrap={false}>
                        <View style={styles.spacing}/>
                        <View style={styles.alertWarning}>
                            <Text style={styles.textSm}>{i18n.t("joindre avertissement")}</Text>
                        </View>
                        <Text style={styles.text}>
                            {i18n.t("MariedLe défunt était indépendant(e)")} {i18n.t(jobPartnerIndependant.Field38Titre)}. {jobPartnerIndependant.Field39BCEempty && i18n.t("Le conjoint ou partenaire du défunt n'avait pas de numéro BCE")
                        }
                        </Text>
                        <Text style={styles.text}>
                            {!!jobPartnerIndependant.Field39BCE && i18n.t("Son numéro BCE est") + " " + jobPartnerIndependant.Field39BCE }.
                        </Text>
                        <Text style={styles.text}>
                            {jobPartnerIndependant.Field40Status === "dirigeant" && i18n.t("Le conjoint du défunt travaille en tant que dirigeant d’une société et il gagne ainsi")
                            + " " + jobPartnerIndependant.Field40StatusBenefice + " "}
                            {jobPartnerIndependant.Field40Status === "societe" && i18n.t("Le conjoint du défunt travaille en tant que société d’une personne et il gagne ainsi")
                            + " " + jobPartnerIndependant.Field40StatusBenefice + " "}
                            {jobPartnerIndependant.Field40Status === "personnephysique" && i18n.t("Le conjoint du défunt travaille en tant qu'indépendant personne physique et il gagne ainsi")
                            + " " + jobPartnerIndependant.Field40StatusBenefice + " "}
                            {i18n.t("en bénéfices imposables et le montant des frais fixes est à")} {jobPartnerIndependant.Field40StatusFrais} {i18n.t("euros")}.
                        </Text>
                    </View>
                    }
                    {!!jobPartnerStudent &&
                    <View wrap={false}>
                        <View style={styles.spacing}/>
                        <Text style={styles.text}>
                            {i18n.t("L'école du conjoint du défunt est") + " " + jobPartnerStudent.Field43School}
                        </Text>
                        <Text style={styles.text}>
                            {i18n.t("Il y fait des études de") + " " + jobPartnerStudent.Field44Nature}
                        </Text>
                        <Text style={styles.text}>
                            {i18n.t("C’est une formation de") + " " + jobPartnerStudent.Field45Duration + " " + i18n.t("ans")}
                        </Text>
                        <Text style={styles.text}>
                            {i18n.t("Il se trouve en") + " " + jobPartnerStudent.Field46Year} {jobPartnerStudent.Field46Year === "1" ? i18n.t("ière") : i18n.t("ième")} {i18n.t("année")}
                        </Text>
                    </View>
                    }

                </View>}
                <View style={styles.bordered}>
                    <View>
                        <Text style={styles.subtitle}>{i18n.t("L’accident et ses conséquences")}
                        </Text>
                        <Text style={styles.text}>{i18n.t("L'accident a eu lieu le")} {moment(circumstances.Field2and3DateAccident).format('DD/MM/YYYY')} {!!circumstances.Field2and3HourAccident && i18n.t("àXheure") + " "+ circumstances.Field2and3HourAccident} {i18n.t("à")} {circumstances.Field4LocationAccident}</Text>
                        <Text style={styles.text}>
                            {d? i18n.t("Mon proche est décédé") : i18n.t("J'ai été blessé")}: {(circumstances.Field5How ==="conducteur") && i18n.t("field5HowConducteurFinal")}
                            {(circumstances.Field5How ==="passager") && i18n.t("field5HowPassagerFinal")}
                            {(circumstances.Field5How ==="velo") && i18n.t("field5HowVeloFinal") + (circumstances.Field5HowVelo ==="veloElec") && i18n.t("field5HowVeloElec")} {!!circumstances.Field5HowVeloElecType && "(" + circumstances.Field5HowVeloElecType + (!!circumstances.Field5HowVeloElecBrand ? ", " + circumstances.Field5HowVeloElecBrand + ")" : ")")}
                            {(circumstances.Field5How ==="step") && i18n.t("field5HowStepFinal") + " ("+ circumstances.Field5HowStepType
                            + ", " + circumstances.Field5HowStepBrand+")."}
                            {(circumstances.Field5How ==="participantcirculation") && i18n.t("field5HowParticipantcirculationFinal") + " ("+circumstances.Field5HowCirculation+ ")."

                            }
                            {(circumstances.Field5How ==="sport") &&
                            <Text style={styles.text}>{i18n.t("field5HowSportFinal")}</Text>
                            }
                            {(circumstances.Field5How ==="autre") &&
                            <Text style={styles.text}>{circumstances.Field5HowOther}</Text>
                            }
                        </Text>

                        {!!circumstances.Field47TypeAccident && <Text style={styles.text}>{d? i18n.t("Pour le défunt, il s’agit") + " "+ i18n.t(circumstances.Field47TypeAccident) : i18n.t("Pour moi, il s’agit") + " "+ i18n.t(circumstances.Field47TypeAccident)}.</Text>}
                        {!!circumstances.Field4701Insurer &&
                        <Text style={styles.text}>
                            {(circumstances.Field47TypeAccident ==="chemintravail") && i18n.t("L’assureur du travail est")+ ": "}
                            {circumstances.Field47TypeAccident ==="cheminecole" && i18n.t("L’assureur scolaire est") + ": "}
                            {circumstances.Field4701Insurer} , {circumstances.Field4702AddressStreet} {circumstances.Field4702AddressStreetNumber}, {!!circumstances.Field4702AddressStreetBox && i18n.t('Boîte postale') + " "+ circumstances.Field4702AddressStreetBox} - {circumstances.Field4702AddressZip}{circumstances.Field4702AddressTown}
                        </Text>
                        }
                        <View style={styles.spacing}/>
                        {(circumstances.Field48Witness ==="no") &&
                        <Text style={styles.text}>{i18n.t("Il n’y a pas de témoins de l’accident.")}
                        </Text>
                        }
                        {(circumstances.Field48Witness ==="yes") &&
                        <Text style={styles.text}>{i18n.t("Il y a des témoins de l’accident")}:
                        </Text>}
                        {(circumstances.Field48Witness ==="yes") &&
                        WitnessesData }
                        <View style={styles.spacing}/>
                        {!!item &&
                        <Text style={styles.subtitle}>{d ? i18n.t("Les conséquences matérielles") : i18n.t("Les conséquences matérielles")}:</Text>
                        }
                        {!!item ? ItemsData :  <Text style={styles.text}>{i18n.t("A part d’éventuels dégâts au véhicule, il n’y a pas d’autres dommages à des objets.")}</Text>
                        }
                        <View style={styles.spacing}/>
                        <View wrap={false}>
                            <Text style={styles.subtitle}>{i18n.t("Les conséquences corporelles")}</Text>
                            <View style={styles.borderTop}/>
                            {!d ?
                                <View>
                                    {!! physical.Field52Wounds &&
                                    <Text style={styles.text}>{i18n.t("Je déclare que mes conséquences corporelles sont")}: {physical.Field52Wounds}
                                    </Text>
                                    }

                                    {(physical.Field53Hospitalized ==="Yes") &&
                                    <Text style={styles.text}>{i18n.t("J’ai été hospitalisé à la suite de l’accident depuis le")} {moment(physical.Field5301HostipalBeginDate).format('DD/MM/YYYY')} {!!physical.Field5303HostipalUntilNow  ? i18n.t("jusqu'à présent et la date de sortie est indéterminé") : i18n.t("jusqu’au")} {moment(physical.Field5302HostipalEndDate).format('DD/MM/YYYY')}. </Text>
                                    }

                                    {(physical.Field53Hospitalized ==="No") &&
                                    <Text style={styles.text}>{i18n.t("Je n’ai pas été hospitalisé à la suite de l’accident.")}</Text>}
                                    <Text style={styles.text}>{!!physical.Field53HospitalizedDoctorname && i18n.t('Mon médecin traitant et/ou ma clinique est/sont')} {physical.Field53HospitalizedDoctorname}</Text>


                                    {(physical.Field54Incapicity ==="Yes") && !physical.Field5303HostipalUntilNow  && (Age > 25) &&
                                    <Text style={styles.text}>{i18n.t("J’ai été en incapacité de travail depuis le")} {moment(physical.Field5401IncapicityBeginDate).format('DD/MM/YYYY')} {!!physical.Field5403IncapicityUntilNow  ? i18n.t("jusqu'à présent et la date de fin est indéterminé"): i18n.t("jusqu’au") + moment(physical.Field5402IncapicityEndDate).format('DD/MM/YYYY')}.</Text>
                                    }
                                    {((physical.Field54Incapicity ==="Yes") && !physical.Field5303HostipalUntilNow  && (Age >= 15) && (Age <= 25)) &&
                                    <Text style={styles.text}>{i18n.t("J’ai été en incapacité de travail ou en incapacité scolaire depuis le")} {moment(physical.Field5401IncapicityBeginDate).format('DD/MM/YYYY')} {!!physical.Field5403IncapicityUntilNow  ? i18n.t("jusqu'à présent et la date de fin est indéterminé") : i18n.t("jusqu’au") + moment(physical.Field5402IncapicityEndDate).format('DD/MM/YYYY')}.</Text>
                                    }
                                    {((physical.Field54Incapicity ==="Yes") && !physical.Field5303HostipalUntilNow  && (Age < 15))  &&
                                    <Text style={styles.text}>{i18n.t("J’ai été en incapacité scolaire depuis le")} {moment(physical.Field5401IncapicityBeginDate).format('DD/MM/YYYY')} {!!physical.Field5403IncapicityUntilNow  ? i18n.t("jusqu'à présent et la date de fin est indéterminé"): i18n.t("jusqu’au") + moment(physical.Field5402IncapicityEndDate).format('DD/MM/YYYY')}.</Text>
                                    }

                                    {((physical.Field54Incapicity ==="No") && (Age > 25)) &&
                                    <Text style={styles.text}>{i18n.t("Je n’ai pas été en incapacité de travail.")}
                                    </Text>
                                    }
                                    {((physical.Field54Incapicity ==="No") && (Age >= 15) && (Age <= 25)) &&
                                    <Text style={styles.text}>{i18n.t("Je n’ai pas été en incapacité de travail ou en incapacité scolaire.")}</Text>
                                    }
                                    {((physical.Field54Incapicity ==="No") && (Age < 15))  &&
                                    <Text style={styles.text}>{i18n.t("Je n’ai pas été en incapacité scolaire.")}</Text>
                                    }

                                    {((physical.Field55Traitement ==="Yes") && !physical.Field5303HostipalUntilNow ) &&
                                    <Text style={styles.text}>{i18n.t("Je suis encore en traitement.")}</Text>
                                    }
                                    {(physical.Field55Traitement ==="No") &&
                                    <Text style={styles.text}>{i18n.t("Je ne suis plus en traitement.")}
                                    </Text>
                                    }
                                    {(physical.Field56Healed === "Yes") &&
                                    <View>

                                        <Text
                                            style={styles.text}>{i18n.t("Je suis totalement guéri depuis le")} {moment(physical.Field5601HealedBeginDate).format('DD/MM/YYYY')} </Text>
                                        <View style={styles.alertWarning}>
                                            <Text style={styles.textSm}>{i18n.t("field5601HealedBeginDateWarning")}</Text>
                                        </View>
                                    </View>
                                    }
                                    {((physical.Field56Healed ==="No") && !physical.Field5303HostipalUntilNow ) &&
                                    <Text style={styles.text}>{i18n.t("Je ne suis pas encore totalement guéri.")}</Text>
                                    }
                                </View> :
                                <View>
                                    {(physical.Field57Death === "wayHospital" ||  physical.Field57Death === "locationAccident") ? <Text style={styles.text}>{i18n.t("Mon proche est décédé")}</Text>:
                                        <Text style={styles.text}>{i18n.t("Mon proche est décédé le")} {!!physical.Field5302HostipalEndDate && moment(physical.Field5302HostipalEndDate).format('DD/MM/YYYY')} {!!physical.Field58DeathDate && moment(physical.Field58DeathDate).format('DD/MM/YYYY')} </Text>}
                                    {physical.Field57Death === "locationAccident" && <Text style={styles.text}> {i18n.t("field57DeathLocationAccident")}</Text>}
                                    { physical.Field57Death === "wayHospital" && <Text style={styles.text}> {i18n.t("field57DeathWayHospital")}</Text>}
                                    {physical.Field57Death === "deathHospital" && <Text style={styles.text}> {i18n.t("field57DeathHospital")} {!!physical.Field53HospitalizedDoctorname} {i18n.t("où il ou elle avait été hospitalisé à la suite de l’accident depuis le")} {moment(physical.Field5301HostipalBeginDate).format('DD/MM/YYYY')}</Text>}
                                </View>}
                        </View>
                    </View>
                    <View style={styles.spacing}/>
                    <View wrap={false}>
                        <Text style={styles.subtitle}>{i18n.t("L’intervention des assurances")}
                        </Text>
                        <View style={styles.borderTop}/>
                        {(intervention.Field57Intervention ==="No") &&
                        <Text style={styles.text}>{d? i18n.t("A la suite de l’accident, le défunt n'avait pas sollicité l’intervention d’un organisme ou d’un assureur.") :i18n.t("A la suite de l’accident, je n’ai pas (encore) sollicité l’intervention d’un organisme ou d’un assureur.")}
                        </Text>
                        }

                        {(intervention.Field57Intervention === "Yes") &&
                        <View>
                            <Text style={styles.text}>{d? i18n.t("A la suite de l’accident, le défunt avait sollicité l’intervention des organismes ou assureurs suivants"): i18n.t("A la suite de l’accident, j’ai sollicité l’intervention des organismes ou assureurs suivants")} :
                            </Text>
                            {(!!intervention.InterventionCheckbox.field5701AccidentTravail) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701AccidentTravail) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701AccidentTravail")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701AccidentTravailName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701AccidentTravailName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701AccidentTravailRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701AccidentTravailRef}
                                </Text>
                            </View>
                            }

                            {(!!intervention.InterventionCheckbox.field5701Scolaire) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Scolaire) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Scolaire")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701ScolaireName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701ScolaireName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701ScolaireRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701ScolaireRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701FraisMedic) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701FraisMedic) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701FraisMedic")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701FraisMedicName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701FraisMedicName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701FraisMedicRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701FraisMedicRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701Hospi) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Hospi) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Hospi")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701HospiName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701HospiName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701HospiRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701HospiRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701Indiv) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Indiv) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Indiv")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701IndivName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701IndivName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701IndivRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701IndivRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701RevGar) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701RevGar) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701RevGar")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701RevGarName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701RevGarName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701RevGarRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701RevGarRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701DegMat) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701DegMat) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701DegMat")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701DegMatName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701DegMatName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701DegMatRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701DegMatRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701Voyage) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Voyage) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Voyage")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701VoyageName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701VoyageName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701VoyageRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701VoyageRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701Mut) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Mut) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Mut")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701MutName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701MutName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701MutRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701MutRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701CPAS) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701CPAS) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701CPAS")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701CPASName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701CPASName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701CPASRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701CPASRef}
                                </Text>
                            </View>}
                            {(!!intervention.InterventionCheckbox.field5701Autre) && <View style={styles.borderTop}/>}
                            {(!!intervention.InterventionCheckbox.field5701Autre) &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Type d’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{i18n.t("field5701Autre")}
                                </Text>
                            </View>}
                            {!!intervention.Field5701AutreName &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom de l’assureur ou organisme")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701AutreName}
                                </Text>
                            </View>}
                            {!!intervention.Field5701AutreRef &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Référence / Numéro du dossier")}
                                </Text>
                                <Text style={styles.data}>{intervention.Field5701AutreRef}
                                </Text>
                            </View>}

                        </View>
                        }

                        <View style={styles.spacing}/>
                        {!!intervention.Field58Affiliation &&
                        <Text style={styles.text}>{d? i18n.t("Le numéro d’affiliation de mutualité du défunt est"): i18n.t("Mon numéro d’affiliation de mutualité est")} : {intervention.Field58Affiliation}.</Text>
                        }
                        {(intervention.Field59RespCivile ==="yes") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt avait une couverture RC vie privé (assurance familiale) chez"): i18n.t("J’ai une couverture RC vie privé (assurance familiale) chez")} {intervention.Field59RespCivileAssureur} {!!intervention.Field59RespCivileAssureurRef && - i18n.t("Référence / Numéro du dossier")} {intervention.Field59RespCivileAssureurRef}.</Text>
                        }
                        {(intervention.Field59RespCivile ==="no") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt n'avait pas de couverture RC vie Privée (assurance familiale)."): i18n.t("Je n’ai pas de couverture RC vie Privée (assurance familiale).")}</Text>
                        }
                        {(intervention.Field59RespCivile ==="dontknow") &&
                        <Text style={styles.text}>{d? i18n.t("Je ne sais pas si j'ai RC vie Privée (assurance familiale)."): i18n.t("Je ne sais pas si j'ai RC vie Privée (assurance familiale).")}</Text>
                        }
                        {(intervention.Field60Protection ==="yes") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt avait une couverture protection juridique chez"): i18n.t("J’ai une couverture protection juridique chez")} {intervention.Field60ProtectionAssureur} {!!intervention.Field60ProtectionAssureurRef && i18n.t("Référence / Numéro du dossier")} {intervention.Field60ProtectionAssureurRef}.</Text>
                        }
                        {(intervention.Field60Protection ==="no") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt n'avait pas pas de couverture protection juridique."): i18n.t("Je n’ai pas de couverture protection juridique.")}</Text>
                        }
                        {(intervention.Field60Protection ==="dontknow") &&
                        <Text style={styles.text}>{d? i18n.t("Je ne sais pas si j'ai une couverture protection juridique."): i18n.t("Je ne sais pas si j'ai une couverture protection juridique.")}</Text>
                        }
                        {(intervention.Field61RCAuto ==="yes") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt avait une couverture RC auto chez"): i18n.t("J’ai une couverture RC auto chez")}
                            {intervention.Field61RCAutoAssureur} {!!intervention.Field61RCAutoAssureurRef && - i18n.t("Référence / Numéro du dossier")}{intervention.Field61RCAutoAssureurRef}.</Text>
                        }
                        {(intervention.Field61RCAuto ==="no") &&
                        <Text style={styles.text}>{d? i18n.t("Le défunt n'avait pas de couverture RC auto."): i18n.t("Je n’ai pas de couverture RC auto.")}
                        </Text>
                        }
                    </View>
                </View>
                <View style={styles.bordered}>

                    <Text style={styles.subtitle}>{i18n.t("Remarques")}
                    </Text>
                    {(remark.Field61HasRemark ==="no") &&
                    <Text style={styles.text}>{i18n.t("Je déclare de ne plus avoir d’autres remarques suite à mon accident.")}</Text>
                    }
                    {(remark.Field61HasRemark ==="yes") &&
                    <Text style={styles.text}>{remark.Field61Remark}</Text>
                    }
                    <View style={styles.spacing}/>
                    <View wrap={false} style={styles.alertWarning}>
                        <Trans i18nKey={d? "finalText01Death" : "finalText01"}>
                            <Text style={styles.textSm}>Les données à caractère personnel recueillies au moyen du présent document sont traitées par les assureurs destinataires de ce document, responsables de leurs traitements, en vue des finalités suivantes : la gestion des sinistres repris sous rubrique, en particulier la constatation et l’évaluation du dommage encouru à la suite du décès du proche du soussigné; la détection et la prévention de la fraude, le traitement à des fins statistiques.</Text><Text style={styles.textSm}>A ces seules fins, les données peuvent être, si nécessaire, communiquées à d’autres entreprises d’assurances concernées par l’indemnisation du dommage encouru à la suite du décès du proche du soussigné, à leurs représentants en Belgique, à leurs correspondants à l’étranger, à leurs réassureurs, à leurs bureaux de règlement de sinistres, à un expert, à un avocat, à un conseil technique, à l’intermédiaire d’assurances du soussigné ou de son proche décédé et, plus généralement, à toute personne ou entité qui exerce un recours ou contre qui un recours est exercé en relation avec le dommage visé ci-avant.</Text><Text style={styles.textSm}>La base juridique du traitement de données est constituée par les contrats d’assurance (Protection juridique (PJ), Responsabilité civile (RC) ou tout autre contrat) ainsi que par l’obligation qui découle du contrat RC pour l’assureur responsable du traitement d’indemniser, le cas échéant, les victimes de dommages encouru à la suite du décès du proche ou des sinistres repris sous rubrique. Dans l’hypothèse où le présent questionnaire ne serait pas rempli de manière adéquate, l’assureur se trouverait dans l’impossibilité de donner une suite à la présente demande d'intervention. Le traitement se fonde en outre sur l’intérêt légitime de l’assureur de prévenir la fraude à l’assurance et d’élaborer des statistiques.</Text><Text style={styles.textSm}>Les données traitées sont conservées par l’assureur responsable pendant la durée de la gestion du sinistre, qui sera adaptée chaque fois que les circonstances l’exigent. Cette durée sera prolongée par le délai de prescription afin que l’assureur puisse faire face aux éventuels recours qui seraient engagés après la clôture du dossier sinistre.</Text><Text style={styles.textSm}>Lesdites données sont traitées avec la plus grande discrétion et uniquement par les personnes habilitées à le faire.</Text><Text style={styles.textSm}>Les personnes concernées peuvent prendre connaissance des données et, le cas échéant, les faire rectifier au moyen d’une demande datée et signée accompagnée d’une photocopie recto verso de la carte d’identité, adressée à l’assureur destinataire du présent document. Lesdites personnes peuvent en outre, selon les mêmes modalités, et dans les limites prévues par le Règlement général sur la protection des données, s’opposer au traitement de données ou demander la limitation de celui-ci. Elles peuvent aussi demander l’effacement ou la portabilité des données les concernant.</Text><Text style={styles.textSm}>De plus amples informations et notamment les coordonnées du délégué à la protection des données peuvent être obtenues auprès de ce même assureur.</Text><Text style={styles.textSm}>Une réclamation peut le cas échéant être introduite auprès de l’Autorité de Protection des données.</Text><Text style={styles.textSm}> Dans le cadre de la procédure d’indemnisation, l’assureur à l’obligation de respecter « les règles de conduite pour règlement de sinistre : relations avec les victimes d’accidents graves » qui se trouvent sur le site web www.assuralia.be. Toute plainte relative à la bonne application par l’entreprise d’assurances de ce code de conduite est adressée par la victime du dommage encouru à la suite du décès du proche au service des plaintes de l’entreprise concernée, conformément aux règles de conduite pour la gestion des réclamations dans les entreprises d’assurances (disponibles sur <Link src='http://www.assuralia.be' target='_blank'>www.assuralia.be</Link>). Si la réponse donnée par ce service n’est pas satisfaisante pour la victime, celle-ci peut introduire sa plainte auprès de l’Ombudsman des assurances via le site <Link src='http://www.ombudsman-insurance.be' target='_blank'>www.ombudsman-insurance.be</Link>.</Text>
                        </Trans>
                    </View>

                    <View style={styles.spacing}/>
                    <View style={styles.tableLike}>
                        <View style={styles.crossedBox}><Text>X</Text></View>
                        <View>
                            <Text style={styles.textFlex}>{i18n.t("finalText02")}</Text>
                        </View>
                    </View>
                    <View wrap={false}>
                        <View style={styles.spacing}/>
                        {(d || remark.FieldTiercePersonne === "no") &&
                        <View>
                            {(!d && remark.Field0608Signatory !== "") &&
                            <View>
                                <Text style={styles.data}>{  i18n.t("finalTextPdf04") }: {remark.Field0608Signatory}</Text>
                            </View>
                            }
                            <Text style={styles.subtitle}>
                                { d ? i18n.t("Mes coordonnées sont") : i18n.t("ISTIERCE") }:
                            </Text>
                            <View style={styles.borderTop}/>
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("Nom, prénom")}:</Text>
                                <Text style={styles.data}>{remark.Field0601Name} {remark.Field0602Firstname}</Text>
                            </View>
                            {remark.Field0603AddressStreet !== "" &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("ADDRESSDATA")}:</Text>
                                <Text style={styles.data}>{remark.Field0603AddressStreet} {remark.Field0603AddressStreetNumber}, {remark.Field0603AddressStreetBox} - {remark.Field0603AddressZip} {remark.Field0603AddressTown}</Text>
                            </View>
                            }

                            {remark.Field0604Phone !== "" &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("PHONEDATA")}:</Text>
                                <Text style={styles.data}>{remark.Field0604Phone}</Text>
                            </View>
                            }

                            {(d && remark.Field0607Link !== "") &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{d? i18n.t("Lien de la personne signataire avec le défunt") : i18n.t("Lien de la personne signataire avec la victime") }:</Text>
                                <Text style={styles.data}>{remark.Field0607Link}</Text>
                            </View>
                            }


                            {remark.Field0605GSM !== "" &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("GSMDATA")}:</Text>
                                <Text style={styles.data}>{remark.Field0605GSM}</Text>
                            </View>
                            }

                            {remark.Field0606Email !== "" &&
                            <View style={styles.tableLike}>
                                <Text style={styles.labelLg}>{i18n.t("EMAILDATA")}:</Text>
                                <Text style={styles.data}>{remark.Field0606Email}</Text>
                            </View>
                            }

                        </View>}

                        <View style={styles.spacing}/>

                        <View wrap={false} style={styles.signature}>
                            <Text style={styles.text}>{i18n.t("Signature")}
                            </Text>
                        </View>
                    </View>

                </View>






                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                )} fixed />
            </Page>
        </Document>)

};
export default Pdf
